<template>
	<div class="points-claim-wrapper">
		<v-btn ref="btnRef" class="points-claim-btn" @click="openDialog" :disabled="claimed || points <= 0">
			<md-icon v-if="claimed">check</md-icon>
			<md-icon v-else>paid</md-icon>
			<span class="points-claim-btn__text" v-if="claimed">{{ t('PointsRequestSent') }}: {{ claimedPoints }} {{ t('pts') }}</span>
			<span class="points-claim-btn__text" v-else>{{ t('Claim') }}: {{ claimedPoints }} {{ t('pts') }}</span>
		</v-btn>

		<PointsClaimDialog v-model="dialogOpen" :promo-name="promoName" :calculated-points="points" :loading="loading" :overlay-target="overlayTarget" @confirm="handleConfirm" />
	</div>
</template>

<script setup>
import { ref } from 'vue';
import confetti from 'canvas-confetti';
import PointsClaimDialog from './PointsClaimDialog.vue';
import { claimPoints } from '@/api/sales/points';
import { useTranslator } from '@/utils/useTranslator';

const t = useTranslator();

const props = defineProps({
	promoId: { type: String, default: '' },
	deliveryLocationId: { type: [String, Number], default: null },
	promoName: { type: String, default: '' },
	points: { type: Number, default: 0 },
	overlayTarget: { type: Object, default: null },
});

const btnRef = ref(null);
const dialogOpen = ref(false);
const loading = ref(false);
const claimed = ref(false);
const claimedPoints = ref(0);

function openDialog() {
	dialogOpen.value = true;
}

async function handleConfirm({ pointsClaimed, comment }) {
	loading.value = true;
	try {
		await claimPoints({
			promoId: props.promoId,
			deliveryLocationId: props.deliveryLocationId,
			pointsClaimed,
			comment,
		});

		dialogOpen.value = false;
		claimedPoints.value = pointsClaimed;
		claimed.value = true;

		fireConfetti();
	} finally {
		loading.value = false;
	}
}

function fireConfetti() {
	const rect = btnRef.value?.getBoundingClientRect?.() ?? { top: window.innerHeight / 2 };
	const originY = rect ? rect.top / window.innerHeight : 0.5;

	confetti({ particleCount: 120, spread: 80, origin: { x: 0.5, y: Math.min(originY, 0.9) }, colors: ['#f59e0b', '#1c79bb', '#fcd34d', '#ffffff', '#9c1369'] });
	setTimeout(() => confetti({ particleCount: 60, spread: 55, origin: { x: 0.35, y: 0.6 }, colors: ['#f59e0b', '#1c79bb'] }), 200);
	setTimeout(() => confetti({ particleCount: 60, spread: 55, origin: { x: 0.65, y: 0.6 }, colors: ['#f59e0b', '#1c79bb'] }), 350);
}
</script>
